import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-133202f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dates" }
const _hoisted_2 = { class: "added" }
const _hoisted_3 = {
  key: 0,
  class: "kpis p-grid p-nogutter"
}
const _hoisted_4 = { class: "p-col-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpis-title" }, "IOS", -1))
const _hoisted_6 = { class: "kpis-number" }
const _hoisted_7 = { class: "p-col-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpis-title" }, "Android", -1))
const _hoisted_9 = { class: "kpis-number" }
const _hoisted_10 = { class: "p-col-4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "kpis-title" }, "Clicks", -1))
const _hoisted_12 = { class: "kpis-number" }
const _hoisted_13 = { class: "info" }
const _hoisted_14 = { class: "user" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "names" }
const _hoisted_17 = { class: "content-title" }
const _hoisted_18 = { class: "user-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "content-list-item",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'content-item', params: { itemID: _ctx.item.id } })))
  }, [
    _createElementVNode("div", {
      class: "background",
      style: _normalizeStyle(`background-image:url('${_ctx.item?.thumbnails?.medium?.url}');`)
    }, null, 4),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.formatDate(_ctx.item?.publishedAt)), 1)
    ]),
    (_ctx.user?.type === 'admin')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.currentStats?.IOS), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.currentStats?.android), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.currentStats?.clicks), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("img", {
          src: _ctx.item?.owner?.profile?.photo,
          referrerpolicy: "no-referrer",
          alt: ""
        }, null, 8, _hoisted_15)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("h5", _hoisted_17, _toDisplayString(_ctx.item?.title), 1),
        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.item?.owner?.name), 1)
      ])
    ])
  ]))
}